import './App.css';
import { ThemeProvider } from '@material-ui/styles';
import UItheme from "@bamboobox/b2-theme";
import { AuthProvider, useAuthState } from "@bamboobox/b2logincheck";
import {ResourceCheck} from '@bamboobox/b2resource-check/dist'
import React,{useEffect, useState} from 'react';
import { lazy } from 'react';
import { Suspense } from 'react';
import { CircularProgress } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import getTenantConfigJSON from './components/getTenantConfigJson';
const ExportStart = lazy(()=>import('./ExportStart'));
const BloomSegmentManager = lazy(()=>import('./components/bloom/BloomSegmentManager'));

// Decides between the new Bloom UI and the legacy Segment Manager based on the
// `SeggyEnable` tenant config (tool: "Segment-manager"). Rendered inside
// AuthProvider so the tenantId is available via useAuthState.
function SegmentManagerSwitch() {
  const tenantId = useAuthState()?.user?.tenantId;
  // null = still resolving the tenant config
  const [seggyEnabled, setSeggyEnabled] = useState(null);

  useEffect(() => {
    if (!tenantId) return undefined;
    let cancelled = false;
    getTenantConfigJSON(tenantId, 'ExportManager', ['ChatUI'])
      .then((configs) => {
        if (cancelled) return;
        const enable = configs.find((c) => c.configKey === 'ChatUI')?.configVal?.enable;
        setSeggyEnabled(enable === 'true' || enable === true);
      })
      .catch(() => {
        if (!cancelled) setSeggyEnabled(false);
      });
    return () => {
      cancelled = true;
    };
  }, [tenantId]);

  if (seggyEnabled === null) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '57vh' }}>
        <CircularProgress style={{ color: '#21DA8C' }} />
      </div>
    );
  }

  return seggyEnabled ? <BloomSegmentManager /> : <ExportStart />;
}

function App() {
  
//     let location = useLocation();
//     function useQuery() {
//         return new URLSearchParams(location.search);
//     }
//     let GetIcp = () => {
//         return useQuery().get("icp") || '';
//     }
//     let params_url = useQuery().get("icp") || "";
//     const [icp, setIcp] = useState(params_url);


//     React.useEffect(() => {
//       console.log("test icp query changed")
//       setIcp(GetIcp())
//   }, [useQuery().get("icp")])

    const resources=["export_manager"]

    return (
      <div className="App">
        <AuthProvider
          loginURL={window._env_.LOGIN_URL}
          authcheckURL={window._env_.AUTH_URL}
        >
          <ThemeProvider theme={UItheme}>
            <Suspense
              fallback={
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "57vh",
                  }}
                >
                  <CircularProgress style={{ color: "#21DA8C" }} />
                </div>
              }
            >
              {/* <ResourceCheck
                component={<SegmentManagerSwitch />}
                resources={resources}
              /> */}
              <SegmentManagerSwitch />
            </Suspense>
          </ThemeProvider>
        </AuthProvider>
        <ToastContainer />
      </div>
    );
}

export default App;
